import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {FormModel} from '../form.model';
import {FormDefinitionFormConverter} from '../../../../definition/form/api/entity/converter/formDefinitionForm.converter';
import {FormValueConverter} from '../../../value/api/entity/converter/formValue.converter';
import {FormSummaryConverter} from './formSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class FormConverter extends HttpModelConverter<FormModel> {

    constructor(private formDefinitionConverter: FormDefinitionFormConverter,
                private formValueConverter: FormValueConverter,
                private formSummaryConverter: FormSummaryConverter) {
        super();
    }

    protected createInstance(): FormModel {
        return new FormModel();
    }

    protected enrichObject(result: FormModel, src: FormModel) {
        result.summary = this.formSummaryConverter.convert(src.summary);
        result.formDefinition = this.formDefinitionConverter.convert(src.formDefinition);
        result.values = this.formValueConverter.convertFromArray(src.values);
    }
}
